import { Copy } from '../types/copy';

export const polarisHomeSiteCopy: Copy = {
  repairServiceName: '',
  repairServiceShortName: '',
  privacyAndSecurityLink: 'https://go.homesite.com/privacy_policy',
  termsAndConditionsLink: 'https://go.homesite.com/terms-use',
};
